'use client';

// PageNavbar was only visible with demo1 layout which has been removed.
// Kept as a no-op export to avoid breaking imports.
const PageNavbar = () => {
  return <></>;
};

export { PageNavbar };
